import { StatiquePageService } from './../Service/statique-page.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Global } from '../Service/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { take, takeUntil } from 'rxjs/operators';
declare var $: any;



@Component({
  selector: 'app-statique-page',
  templateUrl: './statique-page.component.html',
  styleUrls: ['./statique-page.component.scss']
})
export class StatiquePageComponent implements OnInit,OnDestroy {

  constructor(
    public global: Global,
    private service: StatiquePageService,
    private aroute: ActivatedRoute,
    private router: Router
  ) { }
  datacss = "";
  outputLg;
  titrePage = '';
  section ='';
  urlSection ='';
  url = '';
  lgsub;
  routesub;
  currentUrl;
  ocpm = false;

  ngOnInit(): void {
    this.lgsub = this.global.CurentLanguage.subscribe(lg => {
      this.outputLg=lg;
      this.routesub? this.routesub.unsubscribe(): null;
      this.routesub = this.aroute.params.subscribe(param => {
        if (param['type'] !== null && param['type'] !== undefined) {
       
          const url = this.router.url !== null ? this.router.url.toLowerCase() : '';
          this.url = this.router.url;
          this.currentUrl=this.router.url
//OCPM Modification Start
          // console.log( " url " + url)
          // if (url !== undefined && url !== null) {
          //     if (url == "/services/ocpm") {
          //       this.ocpm = true
          //     }
          //   }

//OCPM Modification End

          if(url.indexOf('/agence/') !== -1) {
            this.section = 'Agence';
            this.urlSection = '/agence/presentation'
          } else if(url.indexOf('/grands-chantiers/') !== -1) { 
            this.section = 'Grands Chantiers';
            this.urlSection = '/grands-chantiers/chantiers-infrastructures'
          }  else if(url.indexOf('/missions/') !== -1) { 
            this.section = 'Missions';
            this.urlSection = '/missions/PortAuthorite'
          }  else if(url.indexOf('/formation-portuaire/') !== -1) { 
            this.section = 'Formation Portuaire';
            this.urlSection = '/formation-portuaire/ifp'
          } else if(url.indexOf('/services/') !== -1) { 
            this. section = 'Services';
            this.urlSection = '/services/portnet'
          }else if(url.indexOf('/publications/') !== -1) { 
            this.section = 'Publications';
            this.urlSection = '/publications/communiques-presse'
          } else if(url.indexOf('/espace-professionnel/') !== -1) { 
            this.section = 'Espace Professionnel';
            this.urlSection = '/espace-professionnel/portnet'
          } else if(url.indexOf('/acces-rapide/') !== -1) { 
            this.section = 'Acces rapide';
            this.urlSection = '/acces-rapide/contact'
          }
          this.service.getPageByNameSection(param['type'], lg.url, this.section).subscribe(datas => {
            if (datas['value'].length > 0) {
              this.service.getMenuBySection(this.section, lg.url).subscribe(menus => {
                menus['value'].forEach(element => {
                  if(element.ApplicationUrl !== null && this.url !== null &&
                    this.url.toLowerCase().indexOf(element.ApplicationUrl.toLowerCase()) !== -1) {
                    this.titrePage = element.Title;
                  }
                });
              })
              const url = this.global._baseUrlRacine + datas['value'][0].File.ServerRelativeUrl;
              $('#content').load(url,()=>{
                $('#content style').remove();
              });
            } else {
              alert('page not found');
              this.router.navigate(['/']);
            }
          });
        }
      });
    });
  }
  ngOnDestroy(){
    this.lgsub.unsubscribe();
  }
}
